export const REALTY_STATUS_ACTIVE = 'active'
export const REALTY_STATUS_DRAFT = 'draft'
export const REALTY_STATUS_ARCHIVE = 'archive'

export const REALTY_DRAFT_STATUS_DRAFT = 'draft'
export const REALTY_DRAFT_STATUS_REJECTED = 'rejected'
export const REALTY_DRAFT_STATUS_ACCEPTED = 'accepted'
